import { LegacyWarningSetting } from "@/lib/api";

/** Legacy per-region warning keys still managed in CMS (coastal/north sea moved to dashboard.warnings). */
export const LEGACY_DASHBOARD_WARNING_SETTING_KEYS = [
  "warnings_water_authorities",
  "warnings_provinces",
] as const satisfies readonly (keyof LegacyWarningSetting)[];

export type LegacyDashboardWarningSettingKey =
  (typeof LEGACY_DASHBOARD_WARNING_SETTING_KEYS)[number];

export function isLegacyDashboardWarningSettingKey(
  key: string,
): key is LegacyDashboardWarningSettingKey {
  return (LEGACY_DASHBOARD_WARNING_SETTING_KEYS as readonly string[]).includes(key);
}
